import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";

const CheckCircle = () => (
  <svg width="65" height="65" viewBox="0 0 65 65" fill="none">
    <circle cx="32.5" cy="32.5" r="30.5" stroke="#FFFFFF" strokeWidth="3" />
    <path d="M20 33l9 9 16-18" stroke="#FFFFFF" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const EmailSent = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => navigate("/mobile/tables"), 2500);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full flex justify-center" style={{ backgroundColor: "#000000" }}  >
        <div className="relative w-full min-h-screen flex flex-col items-center justify-center px-12" style={{ backgroundColor: "#67AF7A" }}>
          <CheckCircle />
          <h1 className="mt-6 font-sansation font-bold text-white text-[24px] text-center">
            Email Sent Succesfully!
          </h1>
          <p className="mt-3 font-opensans text-[#F4F4F5] text-[16px] text-center">
            The receipt has been successfully sent on your email address
          </p>
        </div>
      </div>
    </>
  );
};

export default EmailSent;
